// Splide initialization and utilities

document.addEventListener("DOMContentLoaded", function () {
  let sliderElements = document.querySelectorAll(".col-four");

  sliderElements.forEach((sliderElement) => {
    let splide = new Splide(sliderElement, {
      perMove: 1,
      pagination: false,
      gap: "20px",
      perPage: 4,
      cover: true,
      lazyLoad: "nearby",
      arrowPath:
        "M28.4,21.93H6.93c-.55,0-1-.18-1.37-.55s-.55-.83-.55-1.37.18-1,.55-1.37c.37-.37.83-.55,1.37-.55h21.48l-5.49-5.49c-.39-.39-.57-.83-.55-1.35s.2-.96.55-1.35c.39-.39.84-.59,1.37-.6s.99.17,1.37.55l8.81,8.81c.19.19.33.4.41.63s.12.47.12.72-.04.5-.12.72-.22.43-.41.63l-8.81,8.81c-.39.39-.84.57-1.37.55s-.99-.22-1.37-.6c-.35-.39-.54-.83-.55-1.35s.17-.96.55-1.35l5.49-5.49Z",
      breakpoints: {
        1200: {
          perPage: 4,
        },
        992: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });

    splide.mount();
  });

  // Category Slider initialization
  const categorySlider = document.querySelector("#category-slider");
  if (categorySlider && typeof Splide !== "undefined") {
    new Splide("#category-slider", {
      type: "loop",
      perPage: 6,
      perMove: 1,
      gap: "20px",
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      arrows: false,
      pagination: false,
      breakpoints: {
        1200: { perPage: 4 },
        768: { perPage: 3 },
        480: { perPage: 2 },
      },
    }).mount();
  }
});

